import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "commands"
  static values = {
    commands: Object,
  }

  execute(event) {
    console.debug("execute commands")
    this.send("execute_commands", this.commandsValue, () => {})
  }
}
